import {RsnDialog} from '@raison/ui-kit';
import React, {ReactElement, useState} from 'react';

interface Modal {
    isEnabled: () => boolean;
    isChecked: () => boolean;
    setChecked: () => void;
    render: () => ReactElement;
    key: string;
}

export function HomePageModalsQueue() {
    const modals: Modal[] = [];

    const [closedModals, setClosedModals] = useState<string[]>([]);

    const relevantModals = modals.filter(m => m.isEnabled() && !m.isChecked());
    const currentModal = relevantModals.find(m => !closedModals.includes(m.key));

    const onClose = () => {
        if (!currentModal) {
            return;
        }
        currentModal.setChecked();
        setClosedModals(prev => [...prev, currentModal.key]);
    };

    return <RsnDialog.Controller onClose={onClose}>{currentModal && currentModal.render()}</RsnDialog.Controller>;
}
